import React, { useState, useEffect } from "react";
import ViewCart from "../common/ViewCart";
import { useNavigate } from "react-router-dom";
import { http } from "../../helpers/http";
import Form from "react-bootstrap/Form";
import { patterns, useForm } from "../../helpers/useForm";

import Auth from "../../auth/Auth";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Confirm from "../modals/Confirm";
import { updateFullScreenLoader } from "../../redux/actions/authActions";
import { clearCart, clearTipAdditionalInfo, getCartData } from "../../helpers/help";
import { Nav, Tab } from "react-bootstrap";
import { COUPONS, PAYMENT } from "../../eums/messages";
import { useSearchParams, useLocation } from "react-router-dom";
import AddCartItem from "../modals/AddCartItem";
import AddCardModal from "./AddCardModal";
import { replaceValue, allowNumbersWithNoSpaces } from "../../helpers/help";

// import { loadStripe } from "@stripe/stripe-js";

// const stripePromise = loadStripe("pk_test_wDlYbBsqPdfD9OfHS84AeZhS");

const CheckOut = (props) => {
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const dispatch = useDispatch();
  const viewCartData = useSelector((state) => state.cart?.viewCartData);
  const navigate = useNavigate();
  const [showCardModal, setShowCModalard] = useState(false);
  const [cardDetails, setCardDetails] = useState();
  const [selectedRadio, setSelectedRadio] = useState(0);
  const [account, setAccount] = useState();
  const [card, setCard] = useState();
  const [modalId, setModalId] = useState("");
  const [selectedTab, setSelectedTab] = useState("");
  const [coupon, setCoupon] = useState("");
  let [searchParams] = useSearchParams();
  const paymentStatus = searchParams.get("status");
  const [cardSelect, setCardSelect] = useState(false)
  const [isCouponEntered, setIsCouponEntered] = useState(false);
  const [cardNumber, setCardNumber] = useState("");
  const [cardName, setCardName] = useState("");
  const [cvv, setCvv] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [expMonth, setExpMonth] = useState("");
  const [expYear, setExpYear] = useState("");
  const [error, setErrors] = useState({});
  const [payPalCardData, setPayPayCardData] = useState();

  const { pathname } = useLocation();

  const tokn = searchParams.get('token'); // 10
  const payId = searchParams.get('PayerID');


  const { values, errors, bindField, isValid, setInitialValues } = useForm({
    validations: {
      userName: {
        required: true,
      },
      email: {
        pattern: {
          value: patterns.email,
          message: "Invalid email address.",
        },
        required: true,
      },
      mobileNumber: {
        required: true,
      },
      // zipcode: {
      //   required: true
      // }
    },
  });
  const getCheckoutProfile = () => {
    dispatch(updateFullScreenLoader(true));
    http(
      {
        method: "GET",
        url: `getProfile`,
        isSecure: true,
      },
      (res) => {
        setInitialValues(res.usersDetails);
        dispatch(updateFullScreenLoader(false));
      }
    );
  };
  const formattedExpiryDate = `${expYear}-${expMonth}`;
  const isValidCard = () => {
    let isValid = true;
    /*Required Field */
    if (!cardName) {
      error.cardName = true;
      isValid = false;

    }

    /*Required Field */
    if (!cardNumber) {
      error.cardNumber = true;
      isValid = false;

    }
    if (cardNumber.length < 16) {
      error.invalid_card_number = true;
      isValid = false;

    }
    /*Required Field */
    if (!expiryDate) {
      error.expiryDate = true;
      isValid = false;

    }
    /*Required Field */
    if (!cvv) {
      error.cvv = true;
      isValid = false;

    }
    setErrors({ ...error });
    return isValid;
  };

  const formatAndSetCcNumber = (e) => {


    if (e.key === 'e' || e.key === '-' || e.key === '+') {
      e.preventDefault();
    }
    const inputVal = e.target.value.replace(/ /g, "");
    errors.cardNumber = false;
    let inputNumbersOnly = inputVal.replace(/\D/g, "");

    if (inputNumbersOnly.length > 16) {
      inputNumbersOnly = inputNumbersOnly.substr(0, 16);
    }
    if (inputNumbersOnly.length === 16) {
      errors.invalid_card_number = false;
    }


    const splits = inputNumbersOnly.match(/.{1,4}/g);


    setCardNumber(inputNumbersOnly);
  };

  const handleCardNumberKeyDown = (e) => {
    if (e.key === 'e' || e.key === '-' || e.key === '+') {
      e.preventDefault();
    }
  };


  const upDateProfile = (event) => {
    event.preventDefault();
    dispatch(updateFullScreenLoader(true));
    orderConfirm();
    http(
      {
        method: "POST",
        url: `updateProfile`,
        isSecure: true,
        body: {
          userName: values?.userName,
          email: values?.email,
          countryCode: JSON.parse(localStorage.getItem("__takk_out"))
            ?.countryCode,
          mobileNumber: values.mobileNumber,
        },
      },
      (res) => {
        dispatch(updateFullScreenLoader(false));
      }
    );
  };

  const getCartIds = () => {
    let cartIds = [];
    viewCartData?.dishes?.dishes.forEach((item) => {
      cartIds.push({ cartId: item.cartId });
    });

    return JSON.stringify(cartIds);
  };

  const orderConfirm = () => {
    http(
      {
        method: "POST",
        url: "orderConfirm",
        isSecure: true,
        body: getOrderConfirmData(),
      },
      (res) => {
        if (res.error === "false") {
          //order placed
          toast.success("Order is placed!");
          clearCart();
          clearTipAdditionalInfo();
          // pathname.includes("restro-menu") ? navigate(`/restro-menu/${viewCartData?.dishes?.outletDetails?.outletId}`) : navigate("/profile")
          pathname.includes("restro-menu") ? navigate(`/restro-menu/profile`) : navigate("/profile")
          // navigate("/profile")
        }
        if (res.error === "true") {
          toast.error(res.errorMessage);
        }
      }
    );
  };

  const showCardList = () => {
    http(
      {
        method: "GET",
        url: `getCard?outletId=${viewCartData?.dishes?.outletDetails?.outletId}`,
        isSecure: true,
      },
      (res) => {
        if (res.error === "false") {
          setCard(res)
        } else {

        }
      }
    )
  }

  const checkCoupon = (e) => {
    e.preventDefault();

    http(
      {
        method: "POST",
        url: `addCoupon`,
        isSecure: true,
        body: {
          couponCode: coupon,
          udId: Auth.userInfo()?.udId,
          order_type: "Take Out",
          outletId: viewCartData?.dishes?.outletDetails?.outletId,
        },
      },
      (res) => {
        if (res.error === "false") {
          getCartData();
          // setCoupon("");
          toast.success(COUPONS.ACCEPT);
          setIsCouponEntered(true);
          // updateCoupon();
          return;
        }

        if (res.error === "true") toast.error(res.errorMessage);
      }
    );
  };

  const handleSelect = (data, ind) => {
    setSelectedRadio(ind);
    setAccount(data?.AccountToken)
    setCardDetails(data);
  };

  const handleShow = (acctoken) => {
    setModalId(acctoken);
    setOpenLogoutModal(true);

  };



  // const getPaymentMethodId = () => {
  //   if (selectedTab === "Agli") return cardDetails?.id;
  //   if (selectedTab === "paypal") return 11;
  // };




  const getOrderConfirmData = () => {

    const commonData = {
      outletId: viewCartData?.dishes?.outletDetails?.outletId,
      udId: Auth.userInfo()?.udId,
      netAmount: viewCartData?.dishes?.billTotals[viewCartData?.dishes?.billTotals.length - 1]?.netAmount,
      couponName: viewCartData?.couponName,
      paymentType: 11,
      cartId: getCartIds(),
      order_type: "Take Out",
      orderSuggestions: localStorage.getItem("additionalInfo"),
      tipAmount: viewCartData?.tipAmount || 0,
      donation: "No",
      donationAmount: 0.1,
      subTotalAmount: viewCartData?.subTotalAmount,
      witoutCommissionPrice: viewCartData?.dishes?.witoutCommissionPrice,
      gas_surcharge: viewCartData?.gas_surcharge,
      subtotal_discount: viewCartData?.subtotal_discount,
      delivery_discount: viewCartData?.delivery_discount,
      couponSavingAmount: viewCartData?.couponSavingAmount,
      delivery_fee: viewCartData?.delivery_fee,
      blessings_discount: viewCartData?.blessings_discount,
      order_distance: viewCartData?.order_distance,
      after_discount_subtotal: viewCartData?.after_discount_subtotal,
      groupPaymentAmount: "",
      token: account,
      displayAmount: viewCartData?.netAmount,
      isGroupOrder: "",
      // discount:viewCartData?.
      method: viewCartData?.payment_method_enable

    };

    if (viewCartData?.payment_method_enable == "Paypal") {
      const payPalOrderID = JSON.parse(localStorage.getItem("payPalToken"))?.orderId;
      const payPalData = localStorage.getItem("payPalCardData");
      return {
        ...commonData,
        method: "paypal",
        pay_pal_order_id: payPalOrderID,
        authorization_id: searchParams.get("token"),
        payment_res_arry: payPalData,
      };
    }

    return commonData;
  };

  const checkPaymentConfig = (paymentMethod) => {
    dispatch(updateFullScreenLoader(true));
    http(
      {
        method: "POST",
        url: `checkPaymentConfig`,
        isSecure: true,
        body: {
          paymentType: 11,
          method: viewCartData?.payment_method_enable.toLowerCase(),
          outletId: viewCartData?.dishes?.outletDetails?.outletId,
          netAmount: viewCartData?.dishes?.billTotals[viewCartData?.dishes?.billTotals.length - 1]?.netAmount,
          os: "web",
        },
      },
      (res) => {
        if (res.error === "false") {

          localStorage.setItem("paypalTokenWeb", JSON.stringify(res.payPalToken));
          const url = res.payPalToken.orderCreate.links[1].href;
          window.open(url, "_self");
          // orderConfirm();

          return;
        }
        if (res.error === "true") {
          toast.error(res.errorMessage);
        }
        dispatch(updateFullScreenLoader(false));
      }
    );
  };

  const storedPayPalToken = localStorage?.getItem("payPalToken");

  const pyalPalOrderId = storedPayPalToken ? JSON.parse(storedPayPalToken).orderId : null;

  const payPalCard = (event) => {
    event.preventDefault();
    // if (!isValidCard()) return;
    dispatch(updateFullScreenLoader(true));
    http(
      {
        method: "POST",
        url: "payPalCardRequest",
        isSecure: true,
        body: {
          pay_pal_order_id: pyalPalOrderId ? pyalPalOrderId : "",
          number: cardNumber,
          name: cardName,
          security_code: cvv,
          expiry: formattedExpiryDate,
          os: "web"
        }
      },
      (res) => {
        if (res.error === "false") {
          setPayPayCardData(JSON.stringify(res.cardResponse));
          localStorage.setItem('payPalCardData', JSON.stringify(res.cardResponse));
          orderConfirm();
        }

        if (res.error === "true") {
          toast.error(res.errorMessage);
        }
        dispatch(updateFullScreenLoader(false));
      }
    )
    // 

  }
  const isPlaceOrderButtonDisabled = () => {
    const expYearlen = expiryDate.split("/")
    return !(cardName && cardNumber && cvv && expYearlen[1]?.length === 4);
  };
  // const isDisabled = () => {
  //   if (isValid()) {
  //     if (selectedTab === "Agli" && cardDetails) return false;
  //     if (selectedTab === "Paypal" && paymentStatus === "success") return false;

  //   }
  //   return true;
  // };

  useEffect(() => {
    // if (selectedTab === "paypal" && !searchParams.get("status")) {
    //   checkPaymentConfig("paypal");
    // }
    if (selectedRadio === 0 && card?.getCardList.length) {
      setAccount(card?.getCardList[0].AccountToken);
      setCardDetails(card?.getCardList[0]);
    }
  }, [account, selectedRadio, card]);


  // useEffect(() => {
  //   checkPaymentConfig("Paypal");
  // }, [])

  // useEffect(() => {
  //   // if (paymentStatus === "success") {
  //   //   setSelectedTab("paypal");
  //   //   return;
  //   // }
  //   if (paymentStatus === "cancel") {
  //     toast.error(PAYMENT.FAILED);
  //   }
  // }, [paymentStatus]);




  useEffect(() => {
    if (!Auth.isUserAuthenticated()) {
      navigate("/");
      return;
    }
    getCheckoutProfile();
  }, []);

  useEffect(() => {
    if (viewCartData?.dishes?.outletDetails?.outletId) {
      showCardList();
    }
  }, [viewCartData])

  useEffect(() => {
    if (viewCartData?.dishes?.outletDetails?.outletId) {
      !showCardModal && showCardList();
    }

  }, [showCardModal]);

  useEffect(() => {
    if (viewCartData?.dishes?.outletDetails?.outletId) {
      !openLogoutModal && showCardList();
    }

  }, [openLogoutModal]);


  useEffect(() => {
    let value = expiryDate.split("/");
    setExpMonth(value[0]);
    setExpYear(value[1]);
  }, [expiryDate]);



  // useEffect(() => {
  //   if (payId && tokn) {
  //     orderConfirm();
  //     navigate("/profile")
  //   }
  // }, [payId, tokn])



  useEffect(() => {
    // if (paymentStatus === "success") {
    //   navigate("/profile");
    // }
    if (paymentStatus === "cancel") {
      toast.error(PAYMENT.FAILED);
    }
  }, [paymentStatus]);

  return (
    <>
      <section className="checkout_section">
        <div className="cus_container">
          <button
            className="arrow_back d-inline bg-white"
            onClick={() => navigate(-1)}
          >
            <img src="./assets/img/arrowBack.svg" alt="arrow back" />
            Back
          </button>
          <div className="d-flex mt-4 justify-content-between flex-column-reverse flex-md-row">
            <Form onSubmit={upDateProfile} className="w-100">
              <div className="col-left me-md-4">
                <h4 className="head4 mt-4">Contact Info</h4>
                <div className="white_box p-sm-4 py-4 px-2">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="input-grbox">
                        <label className="blackC">
                          Name<sup>*</sup>
                        </label>
                        <input
                          type="text"
                          name="userName"
                          {...bindField("userName")}
                          className="input_control"
                          placeholder="Enter the Name"
                        />
                      </div>
                      {errors.userName && (
                        <span className="text-danger err small">
                          {errors.userName}
                        </span>
                      )}
                    </div>

                    <div className="col-lg-6 mt-3 mt-lg-0">
                      <div className="input-grbox">
                        <label className="blackC">
                          Email<sup>*</sup>
                        </label>
                        <input
                          type="email"
                          {...bindField("email")}
                          name="email"
                          className="input_control"
                          placeholder="Enter the Email"
                        />
                      </div>
                      {errors?.email && (
                        <span className="text-danger err small">
                          {errors?.email}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="row mt-4">
                    <div className="col-lg-6 ">
                      <div className="input-grbox">
                        <label className="blackC">
                          Phone Number<sup>*</sup>
                        </label>
                        <input
                          type="number"
                          className="input_control"
                          name="mobileNumber"
                          maxLength={10}
                          {...bindField("mobileNumber")}
                          placeholder="Enter the Phone Number"
                        />
                      </div>
                      {errors?.mobileNumber && (
                        <span className="text-danger err small">
                          {errors?.mobileNumber}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <h4 className="head4 mt-4">Coupon</h4>
                <div className="white_box mt-4 p-sm-4 p-2">
                  <div
                    className="row"

                  // className={`row ${!coupon ? "disabled" : ""
                  //   }`}
                  >
                    <div className="col-lg-6 col-sm-8">
                      <div

                        className="input-grbox"

                      >
                        <label className="blackC">Coupon Code</label>

                        <input
                          type="text"
                          name="coupon"
                          className="input_control"
                          placeholder="Your Code"
                          value={coupon}
                          onChange={(e) => setCoupon(e.target.value.toUpperCase())}
                          disabled={isCouponEntered}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-4">
                      <button
                        type="button"
                        className="cusbtn minonehunt mt-4"
                        // disabled
                        // onClick={checkCoupon}
                        onClick={isCouponEntered ? undefined : checkCoupon}
                        disabled={isCouponEntered}
                      >
                        {isCouponEntered ? "Applied" : "Apply"}
                      </button>
                    </div>
                  </div>
                </div>
                <h4 className="head4 mt-4">Payment Info</h4>
                <div className="white_box mt-4 p-sm-4 p-3">
                  {/* <p className="txt">Payment Method</p> */}
                  <div className="tab_checkout">
                    {(viewCartData?.payment_method_enable === "Agli"
                    ) &&
                      viewCartData?.payment_method_enable === "Agli" && (
                        <div className="radio-group ms-0 d-flex justify-content-start align-items-center">
                          {/* <label className="checkbox-btn mb-def">
                            <input
                              type="radio"
                              name="carddefault"
                              checked={true}
                            />
                            <span className="checkmark"></span>
                          </label> */}

                          <label className="ml-0" htmlFor="">Card</label>
                        </div>


                      )}
                    {(viewCartData.payment_method_enable === "Paypal") &&
                      viewCartData.payment_method_enable === "Paypal" && (
                        <>
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="input-grbox">
                                <label className="blackC">
                                  Card Holder Name<sup>*</sup>
                                </label>
                                <input
                                  type="text"
                                  className="input_control"
                                  placeholder="Enter the Name"
                                  value={cardName}
                                  onChange={(e) => {
                                    const re = /^[a-zA-Z ]*$/;
                                    error.cardName = false;
                                    if (e.target.value.match(re)) {
                                      setCardName(e.target.value);

                                    }
                                  }}
                                />
                              </div>
                              {error.cardName === true && (
                                <span className="text-danger fz14">
                                  Required
                                </span>
                              )}

                            </div>

                            <div className="col-lg-6 mt-3 mt-lg-0">
                              <div className="input-grbox">
                                <label className="blackC">
                                  Card Number<sup>*</sup>
                                </label>
                                <input
                                  type="tel"
                                  name="cardNumber"
                                  className="fillinput"
                                  maxlength="16"
                                  placeholder="XXXX - XXXX - XXXX - XXXX"
                                  autoComplete="off"
                                  value={cardNumber}
                                  onChange={formatAndSetCcNumber}
                                  onKeyDown={handleCardNumberKeyDown}
                                />
                              </div>
                              {error.cardNumber === true && (
                                <span className="text-danger fz14">
                                  Required
                                </span>
                              )}
                              {!error.cardNumber &&
                                error.invalid_card_number === true && (
                                  <span className="text-danger fz14">
                                    Please enter upto 16 digits
                                  </span>
                                )}

                            </div>
                          </div>
                          <div className="row mt-4">
                            <div className="col-lg-6 ">
                              <div className="input-grbox">
                                <label className="blackC">
                                  Expiration Date<sup>*</sup>
                                </label>
                                <input
                                  type="tel"
                                  className="fillinput"
                                  placeholder="MM/YYYY"
                                  autoComplete="off"
                                  pattern="^(0[1-9]|1[0-2])\/?([0-9]{4})$"
                                  value={expiryDate}
                                  onChange={(e) => {
                                    errors.expiryDate = false;
                                    const finalValue = replaceValue(e.target.value);
                                    const re =
                                      /^[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~\d]*$/g;
                                    if (e.target.value.match(re)) {
                                      setExpiryDate(finalValue);
                                    }
                                  }}
                                />
                              </div>
                              {error.expiryDate === true && (
                                <span className="text-danger fz14">
                                  Required
                                </span>
                              )}

                            </div>
                            <div className="col-lg-6 ">
                              <div className="input-grbox">
                                <label className="blackC">
                                  CVV<sup>*</sup>
                                </label>
                                <input
                                  type="number"
                                  className="fillinput"
                                  placeholder="***"
                                  value={cvv}
                                  onKeyDown={handleCardNumberKeyDown}
                                  onChange={(event) => {
                                    const { value } = event?.target;
                                    if (
                                      allowNumbersWithNoSpaces(value) &&
                                      value.length < 4
                                    ) {
                                      errors.cvv = false;
                                      setCvv(event.target.value);
                                    }
                                  }}

                                />
                              </div>
                              {error.cvv === true && (
                                <span className="text-danger fz14">
                                  Required
                                </span>
                              )}

                            </div>
                            <button
                              type="button"
                              className="cusbtn btnPayPal mt-4"
                              onClick={payPalCard}
                              disabled={isPlaceOrderButtonDisabled()}
                            //disabled={isDisabled()}
                            // disabled
                            >
                              Place Order with Card
                            </button>

                          </div>
                        </>


                      )}

                    {(viewCartData?.payment_method_enable === "Agli") &&
                      viewCartData.payment_method_enable === "Agli" && (

                        <div className="payment_card_view p-3 mt-3">

                          {
                            card && card?.getCardList.map((item, index) => {
                              const isSelected = index === selectedRadio;

                              // if (!isSelected && selectedRadio === index) {
                              //   setSelectedRadio(0);
                              // }
                              return (
                                <div key={item.id} className="radMCon">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                      <div className="radio-group ms-0">
                                        <label className="checkbox-btn">
                                          <input
                                            type="radio"
                                            name="card2332"
                                            value={item.Account}
                                            checked={isSelected}
                                            onChange={() => {
                                              handleSelect(item, index);
                                            }}
                                          />
                                          <span className="checkmark"></span>
                                        </label>
                                      </div>
                                      <div className="txt me-2 ms-2">
                                        <span className="cardSize">
                                          {/* .{item?.Account.slice(-4)} */}
                                          **** **** **** {item?.Account.slice(-4)}
                                        </span>
                                      </div>
                                    </div>
                                    <span
                                      className="closebtn"
                                      onClick={() => handleShow(item.AccountToken)}
                                    >
                                      <img
                                        src="./assets/img/delete_icon.png"
                                        alt="delete_icon"
                                      />
                                    </span>
                                    {/* <div className="line-content-middle my-3"></div> */}
                                  </div>
                                </div>
                              )
                            })
                          }
                          <button
                            type="button"
                            className="newbtn_addcard mt-4 d-flex align-items-center"
                            onClick={() => setShowCModalard(true)}
                          >
                            <span><img src="assets/img/addnewCardIcon.svg" alt="icon" className="me-2" /></span>
                            Add New Card
                          </button>
                        </div>
                      )}
                  </div>
                </div>


                {
                  viewCartData.payment_method_enable === "Paypal" ? (

                    <button
                      // type="submit"
                      type="button"
                      className="cusbtn btnPayPal  mt-4"
                      onClick={checkPaymentConfig}
                    // disabled={isDisabled()}
                    >
                      Place Order with PayPal
                    </button>
                  ) :
                    <button
                      type="submit"
                      className="cusbtn btnsize17 mt-4"
                    // disabled={isDisabled()}
                    >
                      Place Order
                    </button>

                }
              </div>

            </Form>

            <div className="col-right">
              <ViewCart />
            </div>
          </div>
        </div>
      </section>

      <AddCardModal
        showCardModal={showCardModal}
        setShowCModalard={setShowCModalard}
      />

      <Confirm
        openLogoutModal={openLogoutModal}
        setOpenLogoutModal={setOpenLogoutModal}
        card={card}
        account={account}
        setModalId={setModalId}
        modalId={modalId}
      />
      <AddCartItem outletId={viewCartData.dishes?.outletDetails.outletId} />
    </>
  );
};
export default CheckOut;
